export function arraysEqual(a, b) {
  if (a === b) return true
  if (a.length == 0 && b.length == 0) return true
  if (a == null || b == null) return false
  if (a.length != b.length) return false

  for (let i = 0; i < a.length; i++) {
    let element = a[i]
    if (!b.includes(element)) return false
  }

  return true
}

export function sortCaseInsensitive(strA, strB) {
  return strA.toLowerCase().localeCompare(strB.toLowerCase())
}

export function distinctStrings(arr) {
  let values = {}
  let result = []
  arr.forEach(element => {
    if (values[element]) return
    values[element] = true
    result.push(element)
  })

  return result
}

export function mergeDistinctObjectArrays(arrA, arrB, key) {
  let result = {}
  arrA.forEach(element => result[element[key]] = element)
  arrB.forEach(element => result[element[key]] = element)

  return Object.values(result)
}

// Groups an array *xs* by *f* key values
export const groupBy = (xs, f) => xs.reduce(
  (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {}
)
export function splitArray(array, num) {
  let result = []
  for (let i = num; i > 0; i--) {
    result.push(array.splice(0, Math.ceil(array.length / i)))
  }
  return result
}

export function isSubset(son, father) {
  return son.every(x => {
    return father.some(y => {
      return y === x
    })
  })
}
